@if (viewModel()) {
    <bs-linear-module-container [expandable]="isModuleCollapsible" [trackingBetslipTypeContext]="betslipType">
        <ng-template [bsLinearModuleHeader]>
            <div class="single-bet-linear__title-summary-container">
                <div class="single-bet-linear__title">
                    <span>{{ selectedPicksTitle(viewModel().pickCount) }}</span>
                    @if (showGeneralStakeInHeader(viewModel().pickCount)) {
                        <span class="single-bet-linear__stake-all-info">{{ sitecore.betslip.linear.StakeAllSelections }}</span>
                    }
                </div>
                @if (showGeneralStakeInHeader(viewModel().pickCount)) {
                    <bs-linear-single-bet-general-stake class="single-bet-linear__summary" />
                }
            </div>
        </ng-template>
        <ng-template [bsLinearModuleContent]>
            @if (showGeneralStakeInBody(viewModel().pickCount)) {
                <bs-linear-single-bet-general-stake-container [picksCount]="viewModel().pickCount" />
            }
            <bs-digital-pick-list class="single-bet-linear__pick_list">
                @for (pick of viewModel().pickList; track pickTrackBy($index, pick)) {
                    <bs-digital-single-bet-pick
                        [pick]="pick"
                        [singleBetPick]="singleBetPick(viewModel().singleBetState, pick)"
                        [isMultiSingleBet]="isMultiSingleBet()"
                        [oddsDisplayFormat]="oddsDisplayFormat"
                        [removeButtonPosition]="removeButtonPosition"
                        [removeButtonStyle]="removeButtonStyle"
                        [alwaysShowStakeInput]="alwaysShowStakeInput"
                        [msAutomation]="pick.id.toString()"
                        [isLinear]="true" />
                }
            </bs-digital-pick-list>
        </ng-template>
    </bs-linear-module-container>
}
